<template>
  <v-app>
    <v-app-bar
      app
      color="white"
      height="100"
    >
      

      <v-toolbar-title class="d-none d-md-flex">
        <v-row>
          <v-col cols="12 mb-0 pb-0">
            <h2 class="font-weight-black">CIRCUITO DE PALESTRAS DE COMPUTAÇÃO</h2>
          </v-col>
          <v-col cols="12 pt-0 mt-0">
            <span class="text-md-subtitle-1 font-weight-bold"> IFRS - IBIRUBÁ/RS - 20 a 24/07/2020 e 27 a 31/07/2020</span>
          </v-col>
        </v-row>
         
      </v-toolbar-title>

      <v-toolbar-title class="d-flex d-sm-none d-none d-sm-flex d-md-none font-weight-black text-sm-body-1 headline">
        Circuito de Palestras<br>IFRS - Ibirubá
      </v-toolbar-title>
    
    
    
    </v-app-bar>

    <v-content>
      <section id="hero">
        <v-row no-gutters>
          <v-img
            :min-height="'calc(100vh - ' + $vuetify.application.top + 'px)'"
            src="https://images.unsplash.com/photo-1487017159836-4e23ece2e4cf?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1951&q=80"
          >
            <v-theme-provider dark>
              <v-container fill-height>
                <v-row
                  align="center"
                  class="white--text mx-auto"
                  justify="center"
                >
                  <v-col
                    class="white--text text-center"
                    cols="12"
                    tag="h3"
                  >

                    <span
                      class="text-md-h2 text-sm-body-2 text-lg-h2 font-weight-black"
                    >
                      CIRCUITO DE PALESTRAS DE COMPUTAÇÃO
                    </span>
                    

                  </v-col>

                  <v-btn
                    class="align-self-end"
                    fab
                    outlined
                    @click="$vuetify.goTo('#about-me')"
                  >
                    <v-icon>mdi-chevron-double-down</v-icon>
                  </v-btn>
                </v-row>
              </v-container>
            </v-theme-provider>
          </v-img>
        </v-row>
      </section>

      <section id="about-me">
        <div class="py-12"></div>

        <v-container class="text-center">
          <h2 class="text-md-h2 text-sm-body-2 text-lg-h2 font-weight-bold mb-3">O QUE É?</h2>

          <v-responsive
            class="mx-auto mb-8"
            width="56"
          >
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

          <h3 class="display-5 font-weight-bold mb-3">I SEMANA ACADÊMICA TÉC. INTEGRADO EM INFORMÁTICA</h3>
          <h3 class="display-5 font-weight-bold mb-3">V SEMANA ACADÊMICA CIÊNCIA DA COMPUTAÇÃO</h3>

          <v-responsive
            class="mx-auto mb-8"
            width="56"
          >
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

          <v-responsive
            class="mx-auto title font-weight-light mb-8"
            max-width="720"
          >
            O Circuito de Palestras é um evento realizado pelos professores de computação do Instituto Federal de Educação, Ciência e Tecnologia do Rio Grande do Sul, Campus Ibirubá. O evento é realizado para os alunos do curso Técnico Integrado em Informática e Ciência da Computação. O convite se extende a todos profissionais, estudantes e entusiastas da área que tenham interesse nos temas abordados. O evento tem inscrições gratuitas e será transmitido via YouTube.
          </v-responsive>

          <h3 class="display-5 font-weight-bold mb-1">
            <v-icon>mdi-information-outline</v-icon>
            Lembre-se:
          </h3>
          <h3 class="display-6 font-weight-bold mb-1">
            <v-icon>mdi-calendar-month</v-icon> 
            20 a 24/07/2020
          </h3>
          <h3 class="display-6 font-weight-bold mb-3">
            <v-icon>mdi-calendar-month</v-icon> 
            27 a 31/07/2020
          </h3>

          <v-responsive
            class="mx-auto mb-8"
            width="56"
          >
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

          <h3 class="display-6 font-weight-bold mb-3">
            <v-icon>mdi-information-outline</v-icon>
            O evento será trasmitido no Youtube pelo canal:
          </h3>
          <h3>
             <v-btn x-large outlined href="https://www.youtube.com/channel/UC3R1qiMCLzj0o95vuyQl8tA" target="_blank" color="error"><v-icon large>mdi-youtube</v-icon> computacaoibiruba</v-btn>
          </h3>
          

        </v-container>

        <div class="py-12"></div>
      </section>




              <v-sheet
        id="contact"
        color="#333333"
        dark
        tag="section"
        tile
      >
        <div class="py-12"></div>

        <v-container>
          <h2 class="text-md-h3 text-sm-body-2 text-lg-h3 font-weight-bold mb-3 text-uppercase text-center">CONFIRA SUAS PRESENÇAS</h2>

          <v-responsive
            class="mx-auto mb-12"
            width="56"
          >
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

          <v-row class="text-center">
            <v-col class="mb-12">
                <v-btn outlined to="/listarpresencasporusuario" color="white"><v-icon>mdi-file-document</v-icon> Listar Presenças por Usuário</v-btn>
            </v-col>
          </v-row>
        </v-container>

        <div class="py-12"></div>
              </v-sheet>





      <section
        id="features"
        class="grey lighten-3"
      >
        <div class="py-12"></div>

        <v-container class="text-center">
          <h2 class="text-md-h2 text-sm-body-2 text-lg-h2 font-weight-bold mb-3">PALESTRAS</h2>

          <v-responsive
            class="mx-auto mb-12"
            width="56"
          >
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

          <v-row>
            <v-col
              v-for="({ statusPalestra, assinatura, icone, nome, origem, data, texto, youtube }, i) in palestras"
              :key="i"
              cols="12"
              md="4"
            >
              <v-card
                class="py-12 px-4"
                color="grey lighten-5"
                flat
                height="460px"
                elevation="7"
              >
              
                <v-theme-provider dark>
                  <div>
                    
                    <v-avatar
                      color="primary"
                      size="88"
                    >
                      <v-icon
                        large
                        v-text="icone"
                      ></v-icon>
                    </v-avatar>
                  </div>
                </v-theme-provider>

                <v-card-title
                  class="justify-center font-weight-black text-uppercase"
                  v-text="nome"
                ></v-card-title>

                <v-card-subtitle
                  class="justify-center text-uppercase"
                  v-text="origem"
                ></v-card-subtitle>

                <v-alert
                  v-model="alert"
                  color="blue"
                  border="right"
                  elevation="4"
                  colored-border
                >
                  {{data}}
                </v-alert>

                <h5>
                  <v-btn outlined :href="youtube" target="_blank" color="error"><v-icon>mdi-youtube</v-icon> Youtube</v-btn> 
                  <v-btn class="ml-2" outlined v-if="statusPalestra == 'true'" :href="assinatura" color="warning"><v-icon>mdi-pencil</v-icon> Presença</v-btn>
                </h5>

                <v-card-text
                  class="subtitle-1"
                  v-text="texto"
                >
                </v-card-text>
                
              </v-card>
            </v-col>
          </v-row>
        </v-container>

        <div class="py-12"></div>
      </section>

      <section id="stats">
        <v-parallax
          :height="$vuetify.breakpoint.smAndDown ? 700 : 500"
          src="https://images.unsplash.com/photo-1510915228340-29c85a43dcfe?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1950&q=80"
        >
          <v-container fill-height>
            <v-row class="mx-auto">
              <v-col
                v-for="[value, title] of stats"
                :key="title"
                cols="12"
                md="3"
              >
                <div class="text-center">
                  <div
                    class="display-3 font-weight-black mb-4"
                    v-text="value"
                  ></div>

                  <div
                    class="title font-weight-regular text-uppercase"
                    v-text="title"
                  ></div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-parallax>
      </section>

      <section id="blog">
        <div class="py-12"></div>

        <v-container>
          <h2 class="text-md-h2 text-sm-body-2 text-lg-h2 font-weight-bold mb-3 text-uppercase text-center">ACESSE</h2>

          <v-responsive
            class="mx-auto mb-12"
            width="56"
          >
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

          <v-row>
            <v-col
              v-for="({ icone,bg, cor, titulo, link }, i) in links"
              :key="i"
              cols="12"
              md="4"
            >
              <v-card
                  class="mx-auto"
                  max-width="400"
                >
                  
                   <v-img
                      class="white--text align-end"
                      height="150px"
                      :src="bg"
                    >
                      <v-card-title>
                        <v-icon
                          color="white"
                          v-text="icone"
                          class="mr-2"
                        ></v-icon>  
                        {{titulo}}
                      </v-card-title>
                    </v-img>
                  
                  <v-card-subtitle class="pb-0">
                    <div>{{link}}</div>
                  </v-card-subtitle>

                  <v-card-actions>
                    <v-btn
                      :color="cor"
                      text
                      :href="link"
                      target="_blank"
                    >
                      Acessar
                    </v-btn>
                  </v-card-actions>
                </v-card>
            </v-col>
          </v-row>
        </v-container>

        <div class="py-12"></div>
      </section>

      <v-sheet
        id="contact"
        color="#333333"
        dark
        tag="section"
        tile
      >
        <div class="py-12"></div>

        <v-container>
          <v-responsive class="mx-auto mb-12">
            <h2 class="text-md-h2 text-sm-body-2 text-lg-h2 font-weight-bold mb-3 text-uppercase text-center">Inscreva-se gratuitamente</h2>
            <h4 class="text-center">Para receber certificado de participação (Frequência mínima de 75%).</h4>
          </v-responsive>
          
          <v-responsive class="mx-auto mb-12">
            <v-alert
              outlined
              color="yellow"
              border="bottom"
            >
              <h3><v-icon color="yellow">mdi-information-outline</v-icon> Como será calculada a presença?</h3>
              <h4>Durante a palestra, será exibido um QR Code que o participante terá que acessar e, assinar sua presença informando o e-mail que foi cadastrado.</h4>

            </v-alert>
          </v-responsive>

          <v-responsive class="mx-auto mb-12">
            <v-alert
              outlined
              color="yellow"
              border="bottom"
            >
              <h3><v-icon color="yellow">mdi-information-outline</v-icon> Quanto tempo terei para assinar a presença?</h3>
              <h4>Caso você não possa assistir a palestra online, não se preocupe, você poderá assistir e assinar sua presença até <strong>07/08/2020</strong>.</h4>

            </v-alert>
          </v-responsive>

          <v-responsive
            class="mx-auto mb-12"
            width="56"
          >
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

          <v-theme-provider dark>
            <v-form ref="form" v-model="valid" name="inscricao">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  outlined
                  label="Nome completo*"
                  v-model="usuario.nome"
                  :rules="nameRules"
                  required
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  outlined
                  label="Email*"
                  v-model="usuario.email"
                  :rules="emailRules"
                  required
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  outlined
                  label="CPF*"
                  :rules="cpfRules"
                  v-model="usuario.cpf"
                  required
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  outlined
                  label="Origem (curso, instituição ou empresa)*"
                  :rules="origemRules"
                  v-model="usuario.origem"
                  required
                ></v-text-field>
              </v-col>

              <v-col
                class="mx-auto"
                cols="auto"
              >
                <v-btn
                  color="accent"
                  x-large
                  @click="enviar"
                  :disabled="!valid"
                >
                  Enviar
                </v-btn>
              </v-col>
            </v-row>
            </v-form>
          </v-theme-provider>
        </v-container>

        <div class="py-12"></div>
      </v-sheet>
    </v-content>








    <v-dialog
      v-model="dialog"
      max-width="450"
    >
      <v-card>
        <v-card-title class="headline">Confirmação de Inscrição</v-card-title>

        <v-card-text v-if="cadastroSucesso">
          Sua inscrição foi salva com sucesso!
        </v-card-text>
        <v-card-text v-else>
          Houve algum problema ao processar sua inscrição!<br><br>
          <b>Descrição do erro:</b><br> {{erro}}
        </v-card-text>


        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="dialog = false"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogAoVivo"
      max-width="570"
    >
      <v-card>
        <v-card-title class="headline"><v-icon>fas fa-video</v-icon> <span class="ml-3">Estamos AO VIVO</span></v-card-title>
        
        <v-alert
          prominent
          type="warning"
        >
          <v-row align="center">
            <v-col class="grow">Assine Sua Presença</v-col>
            <v-col class="shrink">
              <v-btn
              href="https://semanaacademica2020-f4820.web.app/#/assinarpresenca/00098"
              target="_blank">
                <v-icon>mdi-pencil</v-icon>
                Assinar
              </v-btn>
            </v-col>
          </v-row>
        </v-alert>

        <v-alert
          prominent
          type="info"
        >
          <v-row align="center">
            <v-col>Acesse o canal Computacaoibiruba no Youtube</v-col>
            <v-col class="shrink">
              <v-btn
              href="https://youtu.be/I4YAHpZ-xYQ"
              target="_blank">
                <v-icon>mdi-youtube</v-icon>
                Youtube
              </v-btn>
            </v-col>
          </v-row>
        </v-alert>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="dialogAoVivo = false"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-footer
      class="justify-center"
      color="#292929"
      height="100"
    >
      <div class="title font-weight-light grey--text text--lighten-1 text-center">
        &copy; {{ (new Date()).getFullYear() }} — Computação - IFRS - Ibirubá
      </div>
    </v-footer>
  </v-app>
</template>

<script>
//import VueRecaptcha from 'vue-recaptcha';

export default {
  name: 'App',

  //components: { VueRecaptcha },

  data: () => ({
    dialog: false,
    dialogAoVivo: false,
    cadastroSucesso: false,
    valid: true,
    erro: '',
    nameRules: [
      v => !!v || 'Nome é obrigatório',
    ],
    emailRules: [
      v => !!v || 'E-mail é obrigatório',
      v => /.+@.+\..+/.test(v) || 'E-mail deve ser válido',
    ],
    cpfRules: [
      v => !!v || 'CPF é obrigatório',
      v => (v && v.length <= 11) || 'O CPF deve ter 11 caracteres. Digite apenas os números.',
    ],
    origemRules: [
      v => !!v || 'Origem é obrigatório',
    ],
    usuario: {
      nome: '',
      email: '',
      cpf: '',
      origem: ''
    },
    palestras: [
      {statusPalestra: 'true', assinatura: 'https://semanaacademica2020-f4820.web.app/#/assinarpresenca/11987', youtube: 'https://youtu.be/J8YCYsu3Zec', id: '11987', icone: 'mdi-svg', nome: 'Rogers Prates de Pelle', origem: '(UEMS)', data: '20/07/2020 às 19h', texto: 'Uma reflexão sobre como a pandemia acelerou um movimento natural no mundo corporativo e acadêmico.'},
      {statusPalestra: 'true', assinatura: 'https://semanaacademica2020-f4820.web.app/#/assinarpresenca/22876', youtube: 'https://youtu.be/cT8FumdDcKs', id: '22876', icone: 'mdi-atom', nome: 'Alexandre Zamberlan', origem: '(UFN)', data: '21/07/2020 às 19h', texto: 'Computação e Nanotecnologia'},
      {statusPalestra: 'true', assinatura: 'https://semanaacademica2020-f4820.web.app/#/assinarpresenca/33765', youtube: 'https://youtu.be/5AYpoqwWFpc', id: '33765', icone: 'mdi-home-automation', nome: 'Fernando Marcondes', origem: '(Compasso - Passo Fundo)', data: '22/07/2020 às 19h', texto: 'Reinvenção no modelo de trabalho durante a pandemia'},
      {statusPalestra: 'true', assinatura: 'https://semanaacademica2020-f4820.web.app/#/assinarpresenca/44654', youtube: 'https://youtu.be/_pZwxjFLKzk', id: '44654', icone: 'mdi-traffic-light', nome: 'Lúcio Lopes Diniz', origem: '(Senac)', data: '23/07/2020 às 19h', texto: 'A importância do Teste de Software para a qualidade dos Sistemas'},
      {statusPalestra: 'true', assinatura: 'https://semanaacademica2020-f4820.web.app/#/assinarpresenca/55543', youtube: 'https://youtu.be/6xK_UhdgPiw', id: '55543', icone: 'mdi-stethoscope', nome: 'José Eduardo Venson', origem: '(Grupo Cura)', data: '24/07/2020 às 19h', texto: 'Como desenvolver carreira de computação na área da saúde'},
      {statusPalestra: 'true', assinatura: 'https://semanaacademica2020-f4820.web.app/#/assinarpresenca/66432', youtube: 'https://youtu.be/Zi_lEQ0BWSQ', id: '66432', icone: 'mdi-lead-pencil', nome: 'Lisiane Oliveira', origem: '(IFRS/Unisinos)', data: '27/07/2020 às 19h', texto: 'Territórios de Inventar: Computação e a Educação OnLIFE'},
      {statusPalestra: 'true', assinatura: 'https://semanaacademica2020-f4820.web.app/#/assinarpresenca/77321', youtube: 'https://youtu.be/S6Aer3wqd54', id: '77321', icone: 'mdi-matrix', nome: 'Ernando Silva', origem: '(Stefanini Scala)', data: '28/07/2020 às 19h', texto: 'Business Intelligence: conceitos, ferramentas, aplicações e tendências'},
      {statusPalestra: 'true', assinatura: 'https://semanaacademica2020-f4820.web.app/#/assinarpresenca/88210', youtube: 'https://youtu.be/fPMaaboquaI', id: '88210', icone: 'mdi-flower', nome: 'Roberto Wiest', origem: '(IFSUL - Passo Fundo)', data: '29/07/2020 às 19h', texto: 'Computação e Agro: Pesquisas e Oportunidades'},
      {statusPalestra: 'true', assinatura: 'https://semanaacademica2020-f4820.web.app/#/assinarpresenca/99109', youtube: 'https://youtu.be/2t1-Q9QQIpg', id: '99109', icone: 'mdi-robot', nome: 'Joel Luís Carbonera', origem: '(UFRGS)', data: '30/07/2020 às 19h', texto: 'Inteligência Artificial e suas aplicações'},
      {statusPalestra: 'true', assinatura: 'https://semanaacademica2020-f4820.web.app/#/assinarpresenca/00098', youtube: 'https://youtu.be/I4YAHpZ-xYQ', id: '00098', icone: 'mdi-tablet-ipad', nome: 'Eliane Schlemmer', origem: '(Unisinos)', data: '31/07/2020 às 19h', texto: 'Ecossistemas de Inovação na Educação OnLIFE'},
    ],
  
    links: [
      {icone: 'mdi-youtube', bg: 'yt.png', cor: '#c4302b', titulo: 'Youtube', link: 'https://www.youtube.com/channel/UC3R1qiMCLzj0o95vuyQl8tA'},
      {icone: 'mdi-facebook', bg: 'fb.png', cor: '#4267B2', titulo: 'Facebook C. Computação', link: 'http://fb.com/computacaoibiruba'},
      {icone: 'mdi-facebook', bg: 'fb.png', cor: '#4267B2', titulo: 'Facebook Téc. Informática', link: 'http://fb.com/InfoIfrsIbiruba'},
      {icone: 'mdi-web', bg: 'ws.png', cor: '#00cc00', titulo: 'Website IFRS', link: 'http://ifrs.edu.br'},
      {icone: 'mdi-web', bg: 'ws.png', cor: '#00cc00', titulo: 'Website Campus Ibirubá', link: 'http://ibiruba.ifrs.edu.br'},
      {icone: 'mdi-web', bg: 'ws.png', cor: '#00cc00', titulo: 'Website Info/Computação', link: 'http://inf.ibiruba.ifrs.edu.br'},
    ],
  
    stats: [
      ['2', 'Semanas'],
      ['10', 'Palestras'],
      ['R$0,00', 'Evento Gratuito'],
      ['ACC', 'Acumule Atividades Curriculares Complementares'],
    ],
  }),

  methods: {
    enviar(){
      console.log(this.usuario)
      if( this.usuario.nome == "" || this.usuario.email == "" || this.usuario.cpf == "" || this.usuario.origem == ""){
        this.cadastroSucesso = false
        this.erro = "Campo obrigatório não preenchido"
        this.dialog = true
      }else{
        //this.$recaptcha("inscricao").then(() => {
            this.$http.post('usuarios.json', this.usuario).then(res => {
                console.log(res)
                this.$refs.form.reset()
                this.$refs.form.resetValidation()
                this.cadastroSucesso = true
                this.dialog = true 
              })
              .catch(error => {
                console.log(error)
                this.cadastroSucesso = false
                this.erro = error
                this.dialog = true
              })
        //})
          
      }
          
    },
  }
};
</script>
